export default __webpack_public_path__ + "static/media/delivered.3170f713.svg";